/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import React, { useState } from "react";

import ProductCategorySelector from "@/app/promotions/ProductCategorySelector";
import PromotionSlider from "@/components/element/PromotionSlider";

interface PromotionPageElementProps {
  promoPageData: any;
  allPromoListing: {
    [key: string]: promoListItem[];
  };
}

const promoHeadingLookupTable = {
  tyres: "tyre_category_heading",
  oil: "oil_category_heading",
  brakes: "brake_category_heading",
  batteries: "battery_category_heading",
  suspension: "suspension_category_heading",
  wipers: "wiper_category_heading",
  accessories: "accessories_category_heading",
  other_services: "other_services_category_heading",
};

const PromotionPageElement: React.FC<PromotionPageElementProps> = ({
  promoPageData,
  allPromoListing,
}) => {
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  return (
    <div>
      <section className="flex flex-col items-center justify-center px-4 md:px-14 xl:px-[100px] max-w-[1440px] mx-auto py-10">
        <div className="flex flex-col md:flex-row gap-5 md:gap-10 items-center justify-start md:justify-between w-full">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-medium text-center lg:text-left">
            {promoPageData.page_heading}
          </h1>
          <ProductCategorySelector
            parsedAllPromoData={allPromoListing}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
          />
        </div>
      </section>
      <section className="w-full px-4 md:px-14 xl:px-[100px] max-w-[1440px] mx-auto">
        {Object.entries(allPromoListing).map(([category, promoListData]) => {
          if (promoListData.length > 0) {
            return (
              <div
                key={category}
                className={`${
                  selectedCategory?.currentKey === "all" ||
                  selectedCategory?.currentKey === category ||
                  !selectedCategory
                    ? ""
                    : "hidden"
                } flex flex-col items-center justify-center py-[20px] md:py-10 gap-5 md:gap-10 w-full`}
              >
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-medium text-left w-full">
                  {
                    promoPageData[
                      promoHeadingLookupTable[
                        category as keyof typeof promoHeadingLookupTable
                      ]
                    ]
                  }
                </h2>
                <PromotionSlider promoListData={promoListData} />
              </div>
            );
          }
        })}
      </section>
    </div>
  );
};

export default PromotionPageElement;
